import { z } from 'zod'

export const EMethodosSchema = z.object({
  id: z.number(),
  title: z.string(),
  url: z.string(),
  thumbnail: z.string(),
  order: z.number(),
  visible: z.boolean(),
  tags: z.array(z.string())
})
export const EMethodosListSchema = z.array(EMethodosSchema)

export const EMethodosInputSchema = z.object({
  id: z.number(),
  title: z.string(),
  url: z.string(),
  thumbnail: z.string(),
  order: z.number(),
  visible: z.boolean(),
  tags: z.array(z.string())
})

export type EMethodosEntity = z.infer<typeof EMethodosSchema>
export type EMethodosListEntity = z.infer<typeof EMethodosListSchema>
export type EMethodosInputEntity = z.infer<typeof EMethodosInputSchema>
